export function bandingkanArray(arr1: number[], arr2: number[]) {
    let arr3 = [];
    if (arr1.length === 0) {
        return arr2;
    }
    if (arr2.length === 0) {
        return arr1;
    }
    for (let a of arr2) {
        if (arr1.indexOf(a) > -1) {
            arr3.push(a);
        }
    }
    return arr3;

}

export function kuraingArray(arr1: number[], arr2: number[]) {
    return  arr1.filter(e => !arr2.includes(e));
}


// WEBPACK FOOTER //
// ./src/hotels/hotel-top-filter/bandingkanArray.ts